import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({ text, icon: Icon }) {
  const IconComponent = Icon || Inbox;
  return (
    <div className="py-12 text-center">
      <IconComponent className="w-10 h-10 text-muted-foreground/40 mx-auto mb-3" />
      <p className="text-sm text-muted-foreground">{text}</p>
    </div>
  );
}
